import { render, staticRenderFns } from "./AppealStatus.vue?vue&type=template&id=083e8be2&scoped=true"
import script from "./AppealStatus.vue?vue&type=script&lang=js"
export * from "./AppealStatus.vue?vue&type=script&lang=js"
import style0 from "./AppealStatus.vue?vue&type=style&index=0&id=083e8be2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e8be2",
  null
  
)

export default component.exports